import { defineMessages } from 'react-intl-next';

export const i18n: {
	owner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterOwnerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterOwnerLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterOwnerLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	owner: {
		id: 'search-page.filters.names.owner',
		defaultMessage: 'Owner',
		description: 'Label for filtering by owner',
	},
	confluenceFilterOwnerPlaceholder: {
		id: 'search-page.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterOwnerLabelSelected: {
		id: 'search-page.confluence.filter.contributor.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterOwnerLabelUnselected: {
		id: 'search-page.confluence.filter.contributor.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
});
